var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7951 0C11.0958 0 0 11.1875 0 25C0 36.0625 7.09759 45.4063 16.9536 48.7188C18.1934 48.9375 18.6583 48.1875 18.6583 47.5312C18.6583 46.9375 18.6273 44.9688 18.6273 42.875C12.3975 44.0312 10.7859 41.3438 10.29 39.9375C10.011 39.2188 8.80225 37 7.74846 36.4062C6.88064 35.9375 5.64088 34.7812 7.71747 34.75C9.67008 34.7188 11.0648 36.5625 11.5297 37.3125C13.7613 41.0938 17.3256 40.0312 18.7513 39.375C18.9682 37.75 19.6191 36.6562 20.332 36.0312C14.8151 35.4062 9.05021 33.25 9.05021 23.6875C9.05021 20.9688 10.011 18.7188 11.5917 16.9688C11.3438 16.3438 10.4759 13.7812 11.8397 10.3438C11.8397 10.3438 13.9162 9.6875 18.6583 12.9062C20.6419 12.3438 22.7495 12.0625 24.8571 12.0625C26.9647 12.0625 29.0722 12.3438 31.0558 12.9062C35.7979 9.65625 37.8745 10.3438 37.8745 10.3438C39.2382 13.7812 38.3704 16.3438 38.1224 16.9688C39.7031 18.7188 40.6639 20.9375 40.6639 23.6875C40.6639 33.2812 34.8681 35.4062 29.3512 36.0312C30.25 36.8125 31.0248 38.3125 31.0248 40.6562C31.0248 44 30.9939 46.6875 30.9939 47.5312C30.9939 48.1875 31.4588 48.9688 32.6985 48.7188C42.4926 45.4063 49.5902 36.0312 49.5902 25C49.5902 11.1875 38.4944 0 24.7951 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/githubIcon.6909e1b6dbdd07db0f5866c4c4ae3e3e.svg";
export { ForwardRef as ReactComponent };